import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map'

import { AuthHttp } from 'angular2-jwt';

@Injectable()
export class FacilityService {
    constructor(private http: AuthHttp) { }

    getFacilities(portId, year) {
        return this.http.get('/api/ports/facilities?portId=' + portId + '&year=' + year);
    }

    editFacility(facility): Observable<Response> {
        return this.http.put('/api/ports/facilities', facility)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => {
                return Observable.throw(error.json());
            });
    }

    editFacilityPosition(facility): Observable<Response> {
        return this.http.put('/api/ports/facilities/maps', facility)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => {
                return Observable.throw(error.json());
            });
    }

    addFacility(portId, facilityTypeId, parentFacilityId, title, unit, particularsToDate, mapId, year, x, y): Observable<Response> {
        return this.http.post('/api/ports/facilities',
            {
                portId: portId,
                typeId: facilityTypeId,
                parentFacilityId: parentFacilityId,
                title: title,
                unit: unit,
                particularsToDate: particularsToDate,
                mapId: mapId,
                year: year,
                x: x,
                y: y
            })
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => {
                return Observable.throw(error.json());
            });
    }
}



// WEBPACK FOOTER //
// ./Angular/app/_services/facility.service.ts